//

import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

const OutBoundCallPopup = () => {
  const [transcripts, setTranscripts] = useState([]);
  const SIPCalls = useSelector((state) => state?.SIPCalls);
  const wsRef = useRef(null);
  const transcriptContainerRef = useRef(null);

  // Auto-scroll to bottom when new transcripts arrive
  useEffect(() => {
    if (!transcriptContainerRef.current) return;

    // Use setTimeout to ensure DOM has updated
    const timeoutId = setTimeout(() => {
      if (transcriptContainerRef.current) {
        transcriptContainerRef.current.scrollTo({
          top: transcriptContainerRef.current.scrollHeight,
          behavior: 'smooth',
        });
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [transcripts]);

  useEffect(() => {
    const wsUrl = process.env.REACT_APP_VOIP_WEBSOCKET_BASE_URL_TRANSCRIPT;
    if (!wsUrl) {
      console.error("❌ WebSocket URL not defined");
      return;
    }

    // Close existing connection if any
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close();
    }

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;
    setTranscripts([]);

    ws.onopen = () => {
      console.log("✅ Connected to WebSocket:", wsUrl);
    };

    ws.onerror = (error) => {
      console.error("❌ WebSocket error:", error);
    };

    ws.onclose = (event) => {
      console.log("❌ WebSocket disconnected", event.code, event.reason);
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("📩 WebSocket Data (OutBound):", data);

        // ✅ Check if call ended
        if (data?.text === "__CALL_ENDED__" && data?.channel === "system") {
          console.log("☎️ Call ended — resetting transcript...");

          // Display analysis if available
          if (data?.analysis) {
            console.log("📊 Call Analysis:", data.analysis);
            // Optionally add analysis to transcripts for display
            setTranscripts((prev) => [
              ...prev,
              {
                speaker: "System",
                text: `Call Summary: ${data.analysis.summary}`,
                timestamp: data.timestamp || new Date().toISOString(),
                isAnalysis: true
              },
            ]);
          }

          // Don't clear transcripts immediately so user can see the summary
          // setTranscripts([]);
          // ws.close();
          return;
        }

        // ✅ Handle regular transcript messages (User or Agent channel)
        if (data?.text && (data?.channel === "User" || data?.channel === "Agent")) {
          const speaker = data.channel === "User" ? "User" : "Agent";

          setTranscripts((prev) => [
            ...prev,
            {
              speaker,
              text: data.text,
              timestamp: data.timestamp || new Date().toISOString()
            },
          ]);
        }
      } catch (err) {
        console.error("❌ Invalid WebSocket message:", event.data, err);
      }
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, [SIPCalls?.sipRecentCallUUID]);

  return (
    <div className="activitie p-4">
      <h5 className="text-center">💬 Live Transcript</h5>
      <div
        ref={transcriptContainerRef}
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          paddingRight: "10px",
          paddingBottom: "20px"
        }}
      >
      {transcripts.length > 0 ? (
        transcripts.map((t, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent:
                t.speaker === "User" ? "flex-end" :
                t.isAnalysis ? "center" : "flex-start",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                background: t.isAnalysis ? "#e3f2fd" :
                           t.speaker === "User" ? "#dcf8c6" : "#ffffff",
                padding: "10px 14px",
                borderRadius: "15px",
                maxWidth: t.isAnalysis ? "85%" : "75%",
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                wordWrap: "break-word",
                border: t.isAnalysis ? "1px solid #90caf9" : "none",
              }}
            >
              <strong
                style={{
                  display: "block",
                  fontSize: "0.8rem",
                  color: t.isAnalysis ? "#1976d2" : "#555",
                  marginBottom: "2px",
                }}
              >
                {t.speaker}
              </strong>
              <span style={{ fontSize: "0.9rem" }}>{t.text}</span>
              <div
                style={{
                  textAlign: "right",
                  fontSize: "0.7rem",
                  color: "#999",
                  marginTop: "4px",
                }}
              >
                {new Date(t.timestamp).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted">Waiting for live transcript...</p>
      )}
      </div>
    </div>
  );
};

export default OutBoundCallPopup;
